import { CommonApis } from '@eureka/services/src/apis/common.api';
import { create } from './deferred';
import type { ExperimentPriceKey, ExperimentPriceValue } from '@eureka/services/src/apis/common.api.types';

export const lsPlanDeferred = create<ExperimentPriceValue>();

export const getLsPlan = () => CommonApis.getExperimentItem<ExperimentPriceKey, ExperimentPriceValue>('ls_plg_price').then(res => {
    lsPlanDeferred.resolve(res.experiment_group)
})

getLsPlan();
